<template>
  <div id="add-user-search-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">ADD NEW {{ participantSingularName.toUpperCase() }} SEARCH</h4>
        </div>
        <div class="modal-body">
          <form class="form-horizontal" role="form" v-on:submit.prevent="onSubmit">
            <div class="form-body">
              <div class="form-group form-md-line-input has-warning">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-control input-icon">
                      <i class="fa fa-search"></i>
                      <input type="text" class="form-control" placeholder="Type to search..." v-model="searchQuery" value="">
                      <div class="form-control-focus"></div>
                    </div>
                    <span class="input-group-btn btn-right">
                     <button class="btn green mt-ladda-btn ladda-button search-btn-submit" ref="searchBtn" type="submit" data-style="expand-left">
                        <span class="ladda-label">Search</span>
                     </button>
                    </span>
                  </div>
                </div>
              </div>
              <vue-good-table
                      :columns="columns"
                      :rows="rows"
                      :pagination-options="{
                          enabled: true,
                          perPageDropdown: [10, 20, 50, 100, 200, 500],
                          dropdownAllowAll: true,
                          perPage: this.serverParams.perPage
                      }"
                      mode="remote"
                      v-if="haveResults"
                      :totalRows="totalRecords"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'participant_name'">
                      <router-link v-if="props.row.organization.map(item => item.id).includes(user.organizations[0].id)"
                        :to="{ name: 'Dashboard Participant', params: { id: props.row.id } }" tag="a" class="" data-dismiss="modal" aria-hidden="true">{{ props.row.participant_name }}
                      </router-link>
                      <span v-else>{{ props.row.participant_name }}</span>
                  </span>
                  <span v-else-if="props.column.field == 'date_completed.date'">{{ props.row.date_completed && props.row.date_completed.hasOwnProperty('date') ? props.row.date_completed.date : '' | formatDateModalNoTimeZone }}</span>
                  <span v-else-if="props.column.field == 'date_of_birth.date'">{{ props.row.date_of_birth && props.row.date_of_birth.hasOwnProperty('date') ? props.row.date_of_birth.date : '' | formatDateModalNoTimeZone }}</span>
                  <span v-else-if="props.column.field == 'action'">
                    <button v-if="!props.row.organization.map(item => item.id).includes(user.organizations[0].id)" class="btn btn-sm green" @click="addParticipantFromAnotherOrganization(props.row.id)">Add</button>
                  </span>
                  <span v-else-if="props.column.field == 'organization'">
                    {{ props.row.organization.map(item => item.name).join(',') }}
                  </span>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>
              </vue-good-table>

              <div class="not-found-results" v-if="notFound">
                <h4>Sorry, no search results were found.</h4>
                <h5>Search Suggestions:</h5>
                <ul>
                  <li>Check your spelling</li>
                  <li>Search by {{ participantSingularName }} Name, System ID or Organization ID</li>
                </ul>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <router-link to="/admin/participant" v-if="user.access > 2">
            <button class="btn green" data-dismiss="modal"><i class="fa fa-plus" aria-hidden="true"></i> Add New {{ participantSingularName }}</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {HTTP, ERROR} from '@/http-common';
    import {mapGetters} from 'vuex';
    import participantDisplayName from '@/mixins/participantDisplayName';

    export default {
        mixins: [
            participantDisplayName
        ],
        props: ['refresh'],
        data() {
            return {
                modalTitle: 'Search modal',
                searchQuery: '',
                haveResults: false,
                notFound: false,
                participants: [],
                columns: [],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: '',
                        type: '',
                    },
                    page: 1,
                    perPage: 10
                },
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser'
            })
        },
        methods: {
            onSubmit() {
                if (this.searchQuery.length < 1) {
                    this.haveResults = 0;
                    this.$notify({
                        type: 'error',
                        text: 'Please fill search field.'
                    });
                    return false;
                }
                this.onSearch();
            },

            onSearch() {
                this.button = Ladda.create(document.querySelector('.search-btn-submit'));
                this.button.start();

                HTTP.post(`search`, {
                    keyword: this.searchQuery,
                    limit: this.serverParams.perPage,
                    current_page: this.serverParams.page,
                    in_linked_accounts: ['child', 'parent'].includes(this.user.organizations[0].accountType),
                    in_related_accounts: ['program', 'default'].includes(this.user.organizations[0].accountType)
                }).then(response => {
                    ERROR(response);
                    if (response.status === 200) {
                        this.rows = response.data.data.rows;
                        this.columns =
                            _.map(response.data.data.columns, (column) => {
                                if (column.field.includes('date_')) {
                                    column.thClass = 'vgt-left-align';
                                    column.tdClass = 'vgt-left-align';
                                    column.sortFn = this.dateSortFn;
                                }
                                return column;
                            });

                        this.totalRecords = response.data.data.results_num;

                        let organizationColumn = response.data.data.columns.find(item => item.field === 'organization');

                        if (organizationColumn !== undefined) {

                            let rowsWithAnotherOrganizations = response.data.data.rows.filter(row => {
                                return row.organization.filter(organization => {
                                    return organization.id !== this.user.organizations[0].id
                                }).length;
                            });

                            if (!rowsWithAnotherOrganizations.length) {
                                let cols = this.columns.filter(col => !['action', 'organization'].includes(col.field));
                                this.columns = cols;
                            }
                        }

                        (this.rows.length > 0) ? this.haveResults = true : this.haveResults = false;
                    }

                    this.notFound = this.rows.length === 0;

                    this.button.stop();
                }).catch(err => {
                    console.log(err);
                });
            },

            dateSortFn(x, y, col, rowX, rowY) {
                let xDate = moment(x).unix();
                let yDate = moment(y).unix();
                return (xDate < yDate ? -1 : (xDate > yDate ? 1 : 0));
            },
            addParticipantFromAnotherOrganization(id) {
                $('#add-user-search-modal').modal('hide');
                this.$router.push({name: 'Participant Clone', params: {cloneFromId: id}});
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
                this.onSearch();
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage, page: 1});

            },

            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    },
                });
            },

            onColumnFilter(params) {
                this.updateParams(params);
            }
        },

    watch: {
      refresh: function() {
        this.searchQuery = '';
        this.notFound = false;
        this.haveResults = false;
        this.rows = [];
      }
    },
  }
</script>

<style>
  .table-footer {
    background-color: transparent !important;
  }

  .table thead th, .table.condensed thead th {
    background-color: transparent !important;
  }

  .table input {
    width: 100% !important;
    font-size: 10px !important;
    padding: 6px 0px !important;
    border: none !important;
  }

  .not-found-results {
    padding-top: 10px;
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// AddUserSearchModal.vue?e592eefc